import type { TPartnershipOfferContent } from './types';

import './partnership-offer-content.scss';

export const PartnershipOfferContent = ({ content }: { content: TPartnershipOfferContent }) => {
  return (
    <div className="presentation-layer partnership-offer-content">
      {content.map((item, index) =>
        typeof item === 'string' ? (
          <p className="partnership-offer-content__paragraph" key={item}>
            {item}
          </p>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <ul key={`${item.length}-${index}`}>
            {item.map((listItem) => (
              <li key={listItem}>{listItem}</li>
            ))}
          </ul>
        )
      )}
    </div>
  );
};
